import React, { useEffect } from 'react'
import Quiz from './Quiz'
import Reading from './Reading'
import Video from './Video'
import styled from 'styled-components'
import { courseMutations } from '../../graphql/mutations/'
import { useMutation } from '@apollo/react-hooks';



const Wrapper = styled.div`
    height: calc(100% - 224px);
    overflow: hidden;
    background-color: #f0f0f7;
    @media (max-width: 1050px) {
        height: calc(100% - 296px);
        &.quizContent {
            min-height: calc(100% - 112px)
        }
    }
`

const types = {
    quiz: Quiz,
    leitura: Reading,
    video: Video,
    podcast: Video
}

const Content = props => {
    const { content, loading, error, id, courseId } = props

    const [atualizaUltimoConteudoVisitado] = useMutation(courseMutations.ADD_LAST_VISITED)

    useEffect(() => {
        id && courseId && atualizaUltimoConteudoVisitado({
            variables: {
                conteudoId: id,
                cursoId: courseId
            }
        })
    }, []) // eslint-disable-line
    
    if(loading || error) return null

    const Component = types[content.tipo]
    return <Wrapper className={(content || {}).tipo === 'quiz' ? 'quizContent' : ''}>
        <Component content={content} {...props}/>
    </Wrapper>
}

export default Content